import React from 'react'
import ReactDOM from 'react-dom/client'
import Card from 'react-bootstrap/Card'
import '../../index.css'
import {useEffect, useState} from 'react'
import axios from 'axios'
import dayjs from 'dayjs'

import {
  Column,
  Table as ReactTable,
  PaginationState,
  useReactTable,
  getCoreRowModel,
  getFilteredRowModel,
  getPaginationRowModel,
  ColumnDef,
  OnChangeFn,
  flexRender,
} from '@tanstack/react-table'
import DataTable from 'react-data-table-component'
import {useNavigate} from 'react-router-dom'
import {initialQueryState, KTIcon, useDebounce} from '../../../../_metronic/helpers'

export function PrivilegeList() {
  const navigate = useNavigate()
  const editItem = (data: any) => {
    navigate('/EditPrivilege', {state: data.original})
  }
  const createItem = () => {
    navigate('/CreatePrivilege')
  }
  const testDay = dayjs(new Date()).format('DD-MM-YYYY')
  const [tableData, setTableData] = useState<any>([])
  //const rerender = React.useReducer(() => ({}), {})[1]
  const PVL_URL_V2 = process.env.REACT_APP_PVL_URLV2
  const API_URL = process.env.REACT_APP_API_URL
  const columns = React.useMemo<ColumnDef<any>[]>(
    () => [
      {
        accessorKey: 'image',
        header: () => <span>IMAGE</span>,
        footer: (props) => props.column.id,
        cell: (props) => <img src={props.row.original.deal_image} width={100} />,
      },
      {
        accessorKey: 'deal_name',
        header: 'PRIVILEGE NAME',
        footer: (props) => props.column.id,
      },
      /*{
        accessorKey: 'tags',
        header: 'TAG',
        footer: (props) => props.column.id,
      },*/
      {
        accessorKey: 'lastname',
        header: 'START DATE',
        footer: (props) => props.column.id,
        cell: (props) => (
          <p>
            {props.row.original.dealRules.length > 0
              ? props.row.original.dealRules.map((dealRules_data: any, key: number) => {
                  if (dealRules_data.type == 'redeem' || dealRules_data.type == 'redeem_period') {
                    return dayjs(dealRules_data.start_date).format('DD-MM-YYYY HH:mm:ss')
                  }
                })
              : null}
          </p>
        ),
      },
      {
        accessorKey: 'lastname',
        header: 'END DATE',
        footer: (props) => props.column.id,
        cell: (props) => (
          <p>
            {props.row.original.dealRules.length > 0
              ? props.row.original.dealRules.map((dealRules_data: any, key: number) => {
                  if (dealRules_data.type == 'redeem' || dealRules_data.type == 'redeem_period') {
                    return dayjs(dealRules_data.end_date).format('DD-MM-YYYY HH:mm:ss')
                  }
                })
              : null}
          </p>
        ),
      },
      {
        accessorKey: 'email',
        header: 'ACTIVE',
        footer: (props) => props.column.id,
        cell: (props) => <p>{props.row.original.is_active ? 'Active' : 'Not Active'}</p>,
      },
      {
        accessorKey: 'used_code',
        header: 'USED',
        footer: (props) => props.column.id,
      },
      {
        accessorKey: 'left_code',
        header: 'REMAIN',
        footer: (props) => props.column.id,
      },
      {
        accessorKey: 'created_date',
        header: 'CREATE DATE',
        footer: (props) => props.column.id,
        cell: (props) => <p>{dayjs(props.row.original.created_date).format('DD-MM-YYYY')}</p>,
      },
    ],
    []
  )

  const [data, setData] = React.useState([])
  const [page, setPage] = useState(1)
  const [limit, setLimit] = useState(10)
  const [totalPage, setTotalPage] = useState(1)
  const [totalRow, setTotalRow] = useState(10)
  const [tag, setTag] = useState([{tag_name: '', tag_id: 0}])

  const getAPI = async () => {
    await getTag()
    const data = await axios
      .get(`${PVL_URL_V2}/deal?campaign_id=29&is_count=0&page=1&limit=10`)
      .then(async (res) => {
        await Promise.all(
          res.data.data.map(async (item: any) => {
            await Promise.all(
              item.dealTags.map((item2: any) => {
                console.log(item2)
                let name = tag.find((x) => x.tag_id == item2.tag_id)
                console.log(name, tag)
                item2.tag_name = name ? name.tag_name : ''
              })
            )
          })
        ).then(() => {
          console.log('res', res.data.data)
          setTableData(res.data.data)
          setData(() => res.data.data)
          setPage(1)
          setLimit(res.data.perPage)
          setTotalRow(res.data.total)
          setTotalPage(res.data.totalPage)
        })
      })
    //return data.data.data
  }

  const refreshAPI = async (page: Number, limit: Number) => {
    const data = await axios
      .get(`${PVL_URL_V2}/deal?campaign_id=29&is_count=0&page=${page}&limit=${limit}`)
      .then((res) => {
        setTableData(res.data.data)
        setData(() => res.data.data)
        setLimit(res.data.perPage)
        setTotalRow(res.data.total)
        setTotalPage(res.data.totalPage)
      })
  }

  const [searchTerm, setSearchTerm] = useState<string>('')
  const refreshAPISearch = async (search: string) => {
    setSearchTerm(search)
    const data = await axios
      .get(`${PVL_URL_V2}/deal?campaign_id=29&is_count=0&page=${1}&limit=${limit}&search=${search}`)
      .then((res) => {
        setTableData(res.data.data)
        setData(() => res.data.data)
        setPage(1)
        setTotalRow(res.data.total)
        setTotalPage(res.data.totalPage)
      })
  }
  const getTag = async () => {
    const data = await axios.get(`${API_URL}/privilege/getTagAll`)
    console.log(data.data)
    let temp: any = []
    await Promise.all(
      data.data.map((item: any) => {
        temp.push({
          tag_name: item.tag_name,
          tag_id: item.id,
        })
      })
    )
      .then(async () => {
        console.log(temp)
        setTag(temp)
      })
      .catch()
  }
  const table = useReactTable({
    data,
    columns,
    // Pipeline
    getCoreRowModel: getCoreRowModel(),
    getFilteredRowModel: getFilteredRowModel(),
    getPaginationRowModel: getPaginationRowModel(),
    //
    debugTable: true,
  })
  useEffect(
    () => {
      localStorage.removeItem('data1')
      localStorage.removeItem('data2')
      localStorage.removeItem('data3')
      getAPI()
    },
    [] // Only re-call effect if value or delay changes
  )
  //CreatePrivilege
  return (
    <Card className='table-responsive'>
      <Card.Header>
        <div className='d-flex align-items-center position-relative my-1'>
          <KTIcon iconName='magnifier' className='fs-1 position-absolute ms-6' />
          <input
            type='text'
            data-kt-user-table-filter='search'
            className='form-control form-control-solid w-250px ps-14'
            placeholder='Search user'
            value={searchTerm}
            onChange={(e) => refreshAPISearch(e.target.value)}
          />
        </div>
        {/** add button จุดเพิ่มปุ่ม */}
        <div className='d-flex justify-content-end card-title' data-kt-user-table-toolbar='base'>
          {/*<button type='button' className='btn btn-light-primary me-3'>
            <KTIcon iconName='exit-up' className='fs-2' />
            Export
          </button>*/}

          <button
            type='button'
            className='btn btn-primary'
            onClick={() => {
              createItem()
            }}
          >
            <KTIcon iconName='plus' className='fs-2' />
            Add Privilege
          </button>
        </div>
      </Card.Header>
      <table className='table table-striped gy-7 gs-7'>
        <thead>
          {table.getHeaderGroups().map((headerGroup) => (
            <tr key={headerGroup.id}>
              {headerGroup.headers.map((header) => {
                return (
                  <th key={header.id} colSpan={header.colSpan}>
                    {header.isPlaceholder ? null : (
                      <div className='fw-bold fs-7 text-gray-1200 border-bottom-2 border-gray-200'>
                        {flexRender(header.column.columnDef.header, header.getContext())}
                      </div>
                    )}
                  </th>
                )
              })}
            </tr>
          ))}
        </thead>
        <tbody>
          {table.getRowModel().rows.map((row) => {
            return (
              <tr key={row.id}>
                {row.getVisibleCells().map((cell) => {
                  return (
                    <td key={cell.id}>
                      {flexRender(cell.column.columnDef.cell, cell.getContext())}
                    </td>
                  )
                })}
                {/**add button เพิ่มปุ่ม */}
                <td>
                  <button
                    type='button'
                    className='btn btn-primary mr-3'
                    onClick={() => {
                      editItem(row)
                    }}
                  >
                    Edit
                  </button>
                  <span> </span>
                  <button type='button' className='btn btn-primary ml-2' onClick={() => {}}>
                    Delete
                  </button>
                </td>
              </tr>
            )
          })}
        </tbody>
      </table>
      <div className='h-2' />

      <Card.Footer>
        <span className='flex items-center gap-1'>
          <strong>
            Page {page} of {totalPage}
          </strong>
        </span>
        <span className='flex items-center gap-1 mr-3 p-4'>
          | Go to page:
          <input
            type='number'
            defaultValue={page}
            value={page}
            onChange={(e) => {
              if (Number(e.target.value) <= totalPage && Number(e.target.value) > 0) {
                /*const page = e.target.value ? Number(e.target.value) - 1 : 0
                table.setPageIndex(page)*/
                setPage(Number(e.target.value))
                refreshAPI(Number(e.target.value), limit)
              }
            }}
            className='border p-1 rounded w-16'
          />
        </span>
        <span>
          <select
            className='ml-2'
            value={limit}
            onChange={(e) => {
              setLimit(Number(e.target.value))
              refreshAPI(page, Number(e.target.value))
              table.setPageSize(Number(e.target.value))
            }}
          >
            {[10, 20, 30, 40, 50].map((pageSize) => (
              <option key={pageSize} value={pageSize}>
                Show {pageSize}
              </option>
            ))}
          </select>
        </span>
      </Card.Footer>
    </Card>
  )
}
